import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ProviderInfoStatus, SvgIcon } from '@k12/models';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

export enum StatusBadgeSize {
  Small = '12px',
  Medium = '14px',
  Large = '16px'
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'status-badge',
  imports: [CommonModule, SvgIconComponent, MatButtonModule],
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent {
  @Input() status: ProviderInfoStatus | string | undefined;
  @Input() message: string | undefined;
  @Input() icon!: SvgIcon;
  @Input() svgHeight!: number;
  @Input() svgWidth!: number;
  @Input() badgeSize!: StatusBadgeSize;
  @Input() verified: boolean = false;

  blueCheckIcon = SvgIcon.BlueCheck;
  editIcon = SvgIcon.Edit;

  getStatusBadgeClass(status: string | undefined): string {
    switch (status) {
      case ProviderInfoStatus.InReview:
      case ProviderInfoStatus.Review:
        return 'in-review';
      case ProviderInfoStatus.Approved:
      case ProviderInfoStatus.Active:
        return 'approved';
      case ProviderInfoStatus.Rejected:
      case ProviderInfoStatus.Pending:
      case ProviderInfoStatus.OnHold:
      case ProviderInfoStatus.ClassWallet:
      case ProviderInfoStatus.Denied:
        return 'rejected';
      case ProviderInfoStatus.InPerson:
        return 'in-person';
      case ProviderInfoStatus.Verified:
        return 'verified';
      case ProviderInfoStatus.Suspended:
        return 'suspended';
      default:
        return 'in-review';
    }
  }

  getPaddingClass(): string {
    switch (this.badgeSize) {
      case StatusBadgeSize.Small:
        return 'py-1';
      case StatusBadgeSize.Medium:
        return 'py-2';
      case StatusBadgeSize.Large:
        return 'py-3';
      default:
        return 'py-2';
    }
  }
}
